// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3qWjg","productName":"Table_productName__1pGlc"};